const apiUrl = process.env.REACT_APP_API_URL;

export const shouldShowLegalModal = async (user) => {
    // Si no hay usuario, no mostrar el modal
    if (!user) {
        return false;
    }

    try {
        const localtoken = localStorage.getItem('authToken');
        const response = await fetch(`${apiUrl}/api/v1/last_access_legal_documents`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localtoken}`,
            },
        });

        if (response.ok) {
            const data = await response.json();
            
            if (data.last_access == null) {
                return true;
            }

            return false;
        } else {
            // Si hay error en la API, mostrar el modal por seguridad
            console.error('Error checking legal documents:', response.status);
            return true;
        }
    } catch (error) {
        console.error('Error fetching legal documents status:', error);
        // Si hay error, mostrar el modal por seguridad
        return true;
    }
};

export const markLegalDocumentsAccepted = async (user) => {
    if (!user) {
        return false;
    }

    try {
        const localtoken = localStorage.getItem('authToken');
        const response = await fetch(`${apiUrl}/api/v1/last_access_legal_documents`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localtoken}`,
            }
        });

        if (response.ok) {
            console.log('Legal documents acceptance saved successfully');
            return true;
        } else {
            console.error('Error saving legal documents acceptance:', response.status);
            return false;
        }
    } catch (error) {
        console.error('Error saving legal documents acceptance:', error);
        return false;
    }
};